import { NextImageProps } from '@/components/atoms/image';
import ImageSB, { ImageSBProps } from '@/components/atoms/image/ImageSB';
import { LinkButtonProps } from '@/components/atoms/linkButton';
import { LinkButtonSBProps } from '@/components/atoms/linkButton/LinkSB';
import Popover, { PopoverProps } from '@/components/atoms/popover';
import { BlockComponentModel } from '@/components/cms/types/blok-component';

import { ImageLinkStrapi } from '../imageLink/ImageLinkStrapi';
import { pullDataTrackers } from '../imageLink/utils';

type BasePopupImageLinkStrapiProps = {
  image: ImageSBProps;
};

export type PopupImageLinkStrapiProps = PopupStrapiBlock | LinkStrapiBlock;

type LinkStrapiBlock = BasePopupImageLinkStrapiProps & {
  link: LinkButtonSBProps;
  popup?: ImageSBProps;
};

type PopupStrapiBlock = BasePopupImageLinkStrapiProps & {
  link?: LinkButtonSBProps;
  popup: ImageSBProps;
};

export type PopupImageLinkInner = {
  popup: Partial<PopoverProps>;
  popupImage: Partial<NextImageProps>;
  image: Partial<NextImageProps>;
  link: Partial<LinkButtonProps>;
};

function isLinkBlock(props: any): props is LinkStrapiBlock {
  return !!props.link;
}

export function PopupImageLinkStrapi({
  block,
  inner,
}: BlockComponentModel<PopupImageLinkStrapiProps, PopupImageLinkInner>) {
  const { image, popup } = block;

  if (popup) {
    return (
      <Popover
        target={<ImageSB block={image} inner={inner?.image} />}
        showArrow={true}
        position='right'
        triggerProps={{
          ...pullDataTrackers(inner?.link || {}),
        }}
        {...inner?.popup}
      >
        <ImageSB block={popup} inner={inner?.popupImage} />
      </Popover>
    );
  }

  if (isLinkBlock(block)) {
    return (
      <ImageLinkStrapi
        inner={{
          ...inner?.link,
          classNames: {
            image: 'flex content-center h-6 w-6',
          },
        }}
        block={block}
      />
    );
  }

  return <ImageSB block={image} inner={inner?.image} />;
}
